import { each, closest, select, selectAll } from './utils/dom';
import { isPasswordValid } from '../shared/constants/validation';

// show / hide password on a password field
export default function () {
  window.addEventListener('load', () => {
    const className = 'js-darken';

    // only want to bind form submit handler once
    let formHandlerBound = false;

    const fields = selectAll('.form-field--password');

    if (fields.length === 0) // eslint-disable-line
      return;

    /**
     * Show password
     */
    function showPassword(input, container) {
      input.type = 'text';
      container.classList.add(className)
    }

    function validatePassword(input, container) {
      let valid = isPasswordValid(input.value);

      const fieldToConfirmId = input.dataset.fieldToConfirm;
      if (fieldToConfirmId) {
        const fieldToConfirm = select(`#${fieldToConfirmId}`);
        if (fieldToConfirm) {
          valid = valid && input.value === fieldToConfirm.value;
        }
      }

      const svg = select('.icon-checkmark', container);

      if (svg) {
        if (valid) {
          svg.setAttribute('class', `${svg.getAttribute('class')} js-animate-valid`);
        } else {
          svg.setAttribute('class', `${svg.getAttribute('class').replace(/js-animate-valid/g, '')}`);
        }
      }
    }

    /**
     * Hide password
     */
    function hidePassword(input, container) {
      input.type = 'password';
      container.classList.remove(className);
    }

    /**
     * Toggle password
     */
    function togglePassword(input, container, form) {
      // if Vue already toggled the field, don't do it again
      if (input && !input.classList.contains('toggled')) {
        if (input && input.type === 'password') {
          showPassword(input, container);
          // if a field is ever toggled to "show password", form submission should
          // change that field back to text.
          if (!formHandlerBound) {
            form.addEventListener('submit', () => {
              if (input.type === 'text') {
                input.type = 'password';
              }
            });
            formHandlerBound = true;
          }
        } else if (input && input.type === 'text') {
          hidePassword(input, container);
        }
      }
    }

    // bind event listeners to clicks on the svg
    each(fields, (container) => {
      const input = select('input[type="password"]', container);
      const form = closest('form', container);
      if (input) {
        input.addEventListener('keyup', validatePassword.bind(null, input, container));

        // handle clicks or taps on the SVG
        const button = select('.show-password', container);
        if (button) {
          button.addEventListener('touchstart', togglePassword.bind(null, input, container, form));
          button.addEventListener('click', togglePassword.bind(null, input, container, form));
        }
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/password.js